import { component } from 'picoapp'
import { zelektor, renderProductCard, shuffleArray } from '@/lib/utility-functions.js'

export default component(node => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { list } = zelektor(node)
    const { productId, colIdUnisex, colIdMen, colIdWomen, min, max } = node.dataset

    
    /*******************************************************************************************************************************************/
    /* Init
    /*******************************************************************************************************************************************/
    init()


    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function init() {
        let colId = undefined
        const currentGender = localStorage.getItem('spreeglee_gender') || 'unisex'

        switch (currentGender) {
            case 'unisex':
                colId = colIdUnisex
                break
            case 'men':
                colId = colIdMen
                break
            case 'women':
                colId = colIdWomen
                break
        }

        fetch(`https://middleman.app.grafikrdev.dk/${Shopify.shop.replace('.myshopify.com','')}/products?limit=30${ colId ? `&collection_id=${colId}` : '' }`)
        .then(r => r.json())
        .then(({ data }) => {
            const { products } = data
            products.length < min ? node.remove() : renderProducts(products)
        })
    }

    function renderProducts(products) {
        const sameProduct = products.find(p => p.id === parseInt(productId))
        if (sameProduct) products.splice(products.indexOf(sameProduct),1)

        products = shuffleArray(products).slice(0,max)

        products.forEach(product => {
            const item = document.createElement('div')
            item.classList.add('grid__item')
            list.appendChild(item)

            renderProductCard({ product, parentEl: item, middleMan: true })
        })
    }
})